// extracted by mini-css-extract-plugin
module.exports = {"patternMapItem":"PatternMapItem_patternMapItem__3zkZs","title":"PatternMapItem_title__3JzcS"};